import { ConfigService } from "./config.service";

export function configServiceLoader(configService: ConfigService) {
    return () => configService.load();
}


// WEBPACK FOOTER //
// ./ClientApp/app/_shared/services/config.serviceFactory.ts